import Copy from '../../src/legacy/Copy';
export default Copy;
